import ContactForm from 'components/contact-form';
import ContactMap from 'components/contact-map';
import Hero from 'components/hero';
import Layout from 'components/layout';
import SEO from 'components/seo';
import { GetStaticProps, NextPage } from 'next';
import { REVALIDATE_TIME } from 'settings/config';
import { __DEV__ } from 'utils/helpers';
import { SharedData, sharedDataQuery } from 'utils/queries';
import { usePreviewSubscription } from 'utils/sanity';
import { getClient } from 'utils/sanity-server';

interface ContactProps {
  sharedData?: SharedData;
  preview?: boolean;
}

const Contact: NextPage<ContactProps> = ({ sharedData, preview }) => {
  const { data: shared } = usePreviewSubscription(sharedDataQuery, {
    initialData: sharedData,
    enabled: preview,
  });

  const primaryLocation = shared?.locations.find(
    (location) => location.primary
  );

  return (
    <Layout preview={preview} spaceLinks={shared.spaceInfoPaths}>
      <SEO title='Contact' />
      <Hero
        title='Contact us'
        backgroundColor='green'
        flourishTopLeft='mediumGreen'
        flourishBottomRight='mediumGreen'
      ></Hero>
      <ContactForm
        locations={shared.locations.filter((location) => !location.primary)}
      />
      {primaryLocation && <ContactMap location={primaryLocation} />}
    </Layout>
  );
};

export default Contact;

export const getStaticProps: GetStaticProps<ContactProps> = async ({
  preview = __DEV__,
}) => {
  const sharedData = await getClient(preview).fetch<SharedData>(
    sharedDataQuery
  );

  return {
    props: {
      sharedData,
      preview,
    },
    revalidate: REVALIDATE_TIME,
  };
};
